import $ from "jquery"

// Function that changes section background and text color
function changeSectionBackground(target) {
    var section = document.querySelector('#markets-section');
    var newBackground = target.style.backgroundImage;

    // If the clicked element has class 'active', set the background and add the class to the section
    if (target.classList.contains('markets-area--active')) {
        section.style.backgroundImage = newBackground;
        section.classList.add('has-background');
    } else {
        // If the element does not have the class 'active', the background is removed and we remove the class
        section.style.backgroundImage = 'none';
        section.classList.remove('has-background');
    }
}

var areas = document.querySelectorAll('.markets-area');

// Set background to section from active element when page loads
areas[0].classList.add('markets-area--active');
changeSectionBackground(areas[0]);

areas.forEach(function(area) {
    area.addEventListener('click', function () {
        areas.forEach(function(innerArea) {
            innerArea.classList.remove('markets-area--active');
        });

        area.classList.add('markets-area--active');

        changeSectionBackground(area);
    });
});
